import {EventEmitter, Injectable} from '@angular/core';
import {ExUtilisateur} from '../../class/ex/ex-utilisateur';
import {Utilisateur} from '../../class/api/Utilisateur';
import {UtilisateurSignature} from '../../class/api/UtilisateurSignature';

@Injectable()
export class ProfilManagerService {
    get profil(): ExUtilisateur {
        return this._profil;
    }

    set profil(value: ExUtilisateur) {
        this._profil = value;
    }

    private _profil: ExUtilisateur = null;
    public updateProfil: EventEmitter<string> = new EventEmitter<string>();
    constructor() {}

    public update(user: Utilisateur, keyUpdate: string) {
        if (user['utilisateurRoles'] == undefined) {
            user['utilisateurRoles'] = this._profil['utilisateurRoles'];
        }
        if (keyUpdate != 'laboratoire') {
            user.laboratoire = this._profil.laboratoire;
        }

        if (user['laboratoire'] == undefined) {
            user['laboratoire'] = this._profil.laboratoire;
        }

        this._profil = user as ExUtilisateur;

        this.updateProfil.emit(keyUpdate);
    }

    public setSignature(signature: UtilisateurSignature) {
        const data = this._profil.utilisateurSignatures as UtilisateurSignature[];
        data.push(signature);
        this._profil.utilisateurSignatures = [...this._profil.utilisateurSignatures] as UtilisateurSignature[];
        this._profil = new ExUtilisateur(this._profil);
    }
}
